'use client';

import { useState, useRef } from 'react';

import Popper from '@mui/material/Popper';
import ClickAwayListener from '@mui/material/ClickAwayListener';

import cn from 'classnames';
import { IoMdAdd } from 'react-icons/io';
import { useRouter } from 'next/navigation';

const Option = ({ label, isActive, onClick, isHidden }) => {
  return (
    <button
      className={cn(
        `font-satoshi text-[14px] leading-[19.6px] px-[12px] text-[#686A68] bg-[#F5F5F5] h-[32px] 
        first:rounded-tl-[2px] last:rounded-tr-[2px] hover:bg-white hover:text-[#252526]`,
        {
          '!font-satoshi-bold !bg-[#252526] !text-[#BEAF87]': isActive,
          'dd3-md:hidden': isHidden,
        }
      )}
      onClick={onClick}
    >
      {label}
    </button>
  );
};

const OtherOption = ({ label, isActive, onClick }) => {
  return (
    <button
      className={cn(
        `hidden dd3-md:flex capitalize items-center gap-2 font-satoshi text-[14px] leading-[19.6px] px-[12px] text-[#686A68] bg-[#F5F5F5] h-[32px] 
        first:rounded-tl-[2px] last:rounded-tr-[2px] hover:bg-white hover:text-[#252526]`,
        {
          '!font-satoshi-bold !bg-[#252526] !text-[#BEAF87]': isActive,
        }
      )}
      onClick={onClick}
    >
      {label}

      <IoMdAdd
        className={`text-xl ${isActive ? 'text-[#BEAF87]' : 'text-[#686A68]'}`}
      />
    </button>
  );
};

const DropdownOption = ({ label, isActive, onClick }) => {
  return (
    <button
      className={cn(
        'w-full text-left px-4 py-2 text-[14px] font-satoshi hover:bg-white hover:text-[#252526]',
        {
          'font-satoshi-bold text-[#BEAF87] bg-[#252526]': isActive,
        }
      )}
      onClick={onClick}
    >
      {label}
    </button>
  );
};

const SearchType = ({ propertyType, setPropertyType }) => {
  const router = useRouter();
  const [anchorEl, setAnchorEl] = useState(null);
  const containerRef = useRef(null);

  const handleTogglePopper = () => {
    setAnchorEl(anchorEl ? null : containerRef.current);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOptionClick = (type) => {
    setPropertyType(type);
    handleClose();
  };

  const handleRentSell = () => {
    const url = `/form-sell-rent-property`;
    router.push(url);
  };

  const open = Boolean(anchorEl);

  return (
    <div
      ref={containerRef}
      className="relative bg-[#DEDFDE] flex items-center gap-[2px] rounded-t-[2px] w-fit mb-1"
    >
      <Option
        label="Dijual"
        isActive={propertyType === 'jual'}
        onClick={() => setPropertyType('jual')}
      />
      <Option
        label="Disewa"
        isActive={propertyType === 'sewa'}
        onClick={() => setPropertyType('sewa')}
      />
      <Option
        label="Agent"
        isActive={propertyType === 'agent'}
        onClick={() => setPropertyType('agent')}
        isHidden={true}
      />
      <Option
        label="Titip Jual/Sewa Properti"
        isActive={propertyType === 'consignment'}
        onClick={handleRentSell}
        isHidden={true}
      />
      <Option
        label="Kantor"
        isActive={propertyType === 'kantor'}
        onClick={() => setPropertyType('kantor')}
        isHidden={true}
      />

      <OtherOption
        label={
          propertyType === 'consignment'
            ? 'Titip Jual/Sewa Properti'
            : propertyType
        }
        isActive={['kantor', 'agent', 'consignment'].includes(propertyType)}
        onClick={handleTogglePopper}
        isOther={true}
      />

      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="top-start"
        style={{ zIndex: 1300 }}
        modifiers={[
          {
            name: 'offset',
            options: {
              offset: [0, 8],
            },
          },
        ]}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <div
            className="bg-white shadow-lg rounded-[4px] py-2"
            style={{ width: anchorEl?.offsetWidth }}
          >
            <DropdownOption
              label="Kantor"
              isActive={propertyType === 'kantor'}
              onClick={() => handleOptionClick('kantor')}
            />
            <DropdownOption
              label="Titip Jual/Sewa Properti"
              isActive={propertyType === 'consignment'}
              onClick={handleRentSell}
            />
            <DropdownOption
              label="Agent"
              isActive={propertyType === 'agent'}
              onClick={() => handleOptionClick('agent')}
            />
          </div>
        </ClickAwayListener>
      </Popper>
    </div>
  );
};

export default SearchType;
